import { FileInput, Notification, RichTextEditor, STATUS_TYPES, TEXT_EDITOR_MODES } from "dyl-components";
import { Dimmer, Form, Icon, Loader } from "semantic-ui-react";

import { useContext, useRef, useState } from "react";
import { useController } from "react-hook-form";
import { TemplatesContext } from "./TemplatesContextProvider";
import TemplateSelector from "./TemplateSelector";

const EmailAction = ({
    index,
    id,
    control,
    onFocus
}) => {
    const editorRef = useRef();
    const dropzoneRef = useRef();
    const [mode, setMode] = useState(TEXT_EDITOR_MODES.RICH_TEXT);

    const { emailTemplateOptions, onSelectEmailTemplate } = useContext(TemplatesContext);
    const [isReading, setIsReading] = useState(false);

    const { field: templateCategoryField } = useController({
        name: `actions[${index}].data.template_category`,
        control
    });

    const { field: templateField } = useController({
        name: `actions[${index}].data.template`,
        control
    })

    const { field: bodyField } = useController({
        name: `actions[${index}].data.body`,
        control
    });

    const { field: subjectField } = useController({
        name: `actions[${index}].data.subject`,
        control
    });

    const { field: attachmentsField } = useController({
        name: `actions[${index}].data.attachments`,
        control
    })

    return (
        <>
            <Dimmer active={isReading}>
                <Loader active={isReading} />
            </Dimmer>
            <Form.Group widths='equal'>
                <Form.Field control='div'>
                    <Form.Field
                        control={TemplateSelector}
                        label='Template'
                        categorized_templates={emailTemplateOptions}
                        parentValue={templateCategoryField.value}
                        value={templateField.value}
                        onChange={async (_, { parent_value, child_value: templateId }) => {
                            templateCategoryField.onChange({ target: { name: templateCategoryField.name, value: parent_value } })
                            templateField.onChange({ target: { name: templateField.name, value: templateId } });
                            if (templateId) {
                                try {
                                    setIsReading(true);
                                    const { attachments, content, subject } = await onSelectEmailTemplate(templateId);
                                    subjectField.onChange({ target: { name: subjectField.name, value: subject } })
                                    bodyField.onChange({ target: { name: bodyField.name, value: content || '' } });
                                    attachmentsField.onChange({
                                        target: {
                                            name: attachments, value: (attachments?.data || []).map(attachment => ({
                                                path: attachment.name,
                                                id: attachment.id,
                                                file_id: attachment.file_id,
                                                name: attachment.name,
                                                url: attachment.url
                                            }))
                                        }
                                    });
                                } catch (e) {
                                    console.log(e);
                                } finally {
                                    setIsReading(false);
                                }
                            } else {
                                subjectField.onChange({ target: { name: subjectField.name, value: '' } })
                                bodyField.onChange({ target: { name: bodyField.name, value: '' } });
                                attachmentsField.onChange({
                                    target: {
                                        name: attachmentsField.name, value: []
                                    }
                                });
                            }
                        }}
                        parentName={templateCategoryField.name}
                        onFocus={onFocus}
                    />
                    <Form.Input
                        label='Subject and Body'
                        placeholder='Type email subject'
                        value={subjectField.value}
                        onChange={(_, { value }) => { subjectField.onChange({ target: { name: subjectField.name, value } }) }}
                        style={{ marginBottom: '1em' }}
                        disabled={templateField.value}
                    />
                    <Form.Field
                        control={RichTextEditor}
                        onChange={(_, { value }) => { bodyField.onChange({ target: { name: bodyField.name, value } }) }}
                        value={bodyField.value}
                        toolbarClassName={`email-action-body-toolbar-${id}`}
                        allowSwitchToHTML
                        onSwitchToHTML={() => { setMode(TEXT_EDITOR_MODES.HTML) }}
                        onSwitchToRichText={() => { setMode(TEXT_EDITOR_MODES.RICH_TEXT) }}
                        mode={mode}
                        editorRef={editorRef}
                        size='small'
                        loading={isReading}
                        disabled={templateField.value}
                    />
                </Form.Field>
                <Form.Field
                    control={'div'}
                    disabled
                >
                    <Form.Field
                        label={<div>
                            <Icon onClick={() => { dropzoneRef.current.open(); }} color='blue' name='plus circle' link /> <b>Attach {attachmentsField.value?.length > 0 && 'more '}files</b>
                        </div>}
                    />
                    <div className='Task__attachments'>
                        <FileInput
                            onChange={(_, { value: new_value }) => {
                                attachmentsField.onChange({
                                    target: {
                                        name: attachmentsField.name, value: [
                                            ...(attachmentsField.value?.attachments || attachmentsField.value),
                                            ...new_value.filter(new_file => (
                                                attachmentsField.value.findIndex(file => file.path === new_file.path) === -1
                                            ))
                                        ]
                                    }
                                })
                            }}
                            onReject={(rejected) => {
                                if (rejected.length > 0) {
                                    Notification.alert("File type must be .pdf.", STATUS_TYPES.ERROR, true);
                                }
                            }}
                            onRemove={(_, { value }) => {
                                attachmentsField.onChange({ target: { name: attachmentsField.name, value } })
                            }}
                            files={attachmentsField.value}
                            name="files"
                            accept="application/pdf"
                            icon="file pdf outline"
                            size="mini"
                            dropzoneRef={dropzoneRef}
                            showIcon
                        />
                    </div>
                </Form.Field>
            </Form.Group>
        </>
    )
}

export default EmailAction;
